// The Leaderboard (mockup d-leaderboard.png): /leaderboard, tabs This month / All time / Achievements, the top 3 on a
// podium, the table (member, forum level, main character, achievements, EXP), the viewer's own row, staff flagged.
// Data: GET /api/aethernal/leaderboard?tab= (src/Gamify/Http/LeaderboardController.php). Phones: the table becomes a
// list of cards (the same cells, stacked).
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import { t, ts, nf, api, Roundel, ExpBar, Chip, Medals } from './ui';
const TABS = [['month', 'tab_month'], ['all', 'tab_all'], ['achievements', 'tab_ach']];
function Av(u, size) {
  if (u.avatar) return m("img", {
    className: `Avatar aet-av aet-av--${size}`,
    src: u.avatar,
    alt: "",
    loading: "lazy"
  });
  const ch = (u.name || '?').replace(/^\[[^\]]*\]\s*/, '').charAt(0).toUpperCase();
  return m("span", {
    className: `Avatar aet-av aet-av--${size}`,
    style: {
      '--avatar-bg': u.color || '#5b3fb0'
    }
  }, ch);
}
export default class LeaderboardPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.tab = m.route.param('tab') || 'month';
    if (!TABS.some(([k]) => k === this.tab)) this.tab = 'month';
    this.data = {};
    this.bodyClass = 'App--leaderboard';
    app.setTitle(ts('lb_title'));
    app.setTitleCount(0);
    this.load(this.tab);
  }
  load(tab) {
    this.tab = tab;
    if (this.data[tab]) return;
    api('GET', `/aethernal/leaderboard?tab=${tab}`).then(d => {
      this.data[tab] = d;
      m.redraw();
    });
  }
  valueText(row, d) {
    if (this.tab === 'achievements') return nf(row.value);
    return `${this.tab === 'month' ? '+' : ''}${nf(row.value)}`;
  }
  colTitle(d) {
    if (this.tab === 'achievements') return t('col_unlocked');
    if (this.tab === 'all') return t('col_all');
    let month = d.month;
    try {
      month = new Date(`${d.month}-01T00:00:00Z`).toLocaleDateString(app.data.locale || 'en', {
        month: 'short',
        timeZone: 'UTC'
      });
    } catch (e) {}
    return ts('col_month', {
      month
    });
  }
  name(row, me) {
    const u = row.user;
    return m(Link, {
      className: "aet-lb__who",
      href: app.route('user.aetProgress', {
        username: u.slug
      })
    }, Av(u, 'md'), m("span", {
      className: "aet-lb__nm"
    }, u.name, me ? m("span", {
      className: "aet-lb__you"
    }, " ", t('you')) : null), row.staff ? m("span", {
      className: "aet-lb__staff",
      title: ts('staff')
    }, m("i", {
      className: "icon fas fa-user-shield",
      "aria-hidden": "true"
    }), m("span", null, t('staff'))) : null);
  }
  row(row, d, me = false) {
    const u = row.user;
    return m("tr", {
      className: me ? 'is-me' : ''
    }, m("td", {
      className: "aet-lb__pos"
    }, row.pos), m("td", {
      "data-label": ts('col_member')
    }, this.name(row, me)), m("td", {
      "data-label": ts('col_level')
    }, m("span", {
      className: "aet-lb__lv"
    }, Roundel(u), ExpBar(u.pct))), m("td", {
      "data-label": ts('col_main')
    }, Chip(u.chip)), m("td", {
      "data-label": ts('col_ach')
    }, Medals(u.medals, 3, u.achN)), m("td", {
      className: "aet-lb__val",
      "data-label": this.colTitle(d)
    }, this.valueText(row, d)));
  }
  pod(row, d, first) {
    if (!row) return m("div", {
      className: "aet-pod aet-pod--empty"
    });
    const u = row.user;
    return m("div", {
      className: `aet-pod${first ? ' aet-pod--first' : ''} aet-t-${{
        newcomer: 'bronze',
        adventurer: 'silver',
        veteran: 'gold',
        champion: 'rune',
        legend: 'lantern'
      }[u.tier]}`
    }, m("span", {
      className: "aet-pod__pos"
    }, row.pos), m(Link, {
      href: app.route('user.aetProgress', {
        username: u.slug
      }),
      className: "aet-pod__link"
    }, Av(u, first ? 'xl' : 'lg'), m("span", {
      className: "aet-pod__nm"
    }, u.name)), row.staff ? m("span", {
      className: "aet-lb__staff"
    }, t('staff')) : null, m("div", {
      className: "aet-pod__sc"
    }, Roundel(u), m("span", null, m("b", null, this.valueText(row, d)), " ", this.tab === 'achievements' ? '' : t('exp'))), Chip(u.chip), Medals(u.medals, 3, u.achN));
  }
  view() {
    const d = this.data[this.tab];
    return m("div", {
      className: "aet-lb"
    }, m("div", {
      className: "aet-lb__hero"
    }, m("h1", null, t('lb_title')), m("p", null, t('lb_intro')), m("div", {
      className: "aet-tabs",
      role: "tablist"
    }, TABS.map(([k, label]) => m("button", {
      type: "button",
      role: "tab",
      "aria-selected": this.tab === k ? 'true' : 'false',
      className: this.tab === k ? 'is-on' : '',
      onclick: () => this.load(k)
    }, t(label))))), m("div", {
      className: "container aet-lb__body"
    }, d ? this.board(d) : m(LoadingIndicator, null)));
  }
  board(d) {
    const rows = d.rows || [];
    if (!rows.length) return m("p", {
      className: "aet-note aet-note--center"
    }, t('lb_empty'));
    const meId = app.session.user && app.session.user.id();
    const meIn = rows.some(r => r.user.id === meId);
    const rest = rows.slice(3);
    return [m("div", {
      className: "aet-podium"
    }, this.pod(rows[1], d, false), this.pod(rows[0], d, true), this.pod(rows[2], d, false)), m("section", {
      className: "aet-card aet-lb__table"
    }, m("table", {
      className: "aet-lbt"
    }, m("thead", null, m("tr", null, m("th", null), m("th", null, t('col_member')), m("th", null, t('col_level')), m("th", null, t('col_main')), m("th", null, t('col_ach')), m("th", {
      className: "aet-lb__val"
    }, this.colTitle(d)))), m("tbody", null, rest.map(r => this.row(r, d, r.user.id === meId)), d.me && !meIn ? [m("tr", {
      className: "aet-lb__gap"
    }, m("td", {
      className: "aet-lb__pos"
    }, "\u22EE"), m("td", {
      colspan: "5"
    })), this.row(d.me, d, true)] : null)), m("p", {
      className: "aet-note"
    }, m("i", {
      className: "icon fas fa-circle-info",
      "aria-hidden": "true"
    }), m("span", null, t('lb_note'))))];
  }
}
flarum.reg.add('aethernal-forum', 'forum/gamify/LeaderboardPage', LeaderboardPage);